var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.option === 1)?_c('CardAgenda'):_vm._e(),(_vm.option === 2)?_c('CardCalendario'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }